export default __webpack_public_path__ + "static/media/TAG.554455b8.png";